// @flow
import api from '../api/saveSearch';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { getItemSavedSearchQuery } from '../../utils/ItemPageUtils';
import type { GlobalState } from '../rootReducer';
import { LOCATION_CHANGE } from 'connected-react-router';

/* Action Types */
export const SAVE_SEARCH_CHECK_FAIL = 'la/ui/saveSearchCheck/FAIL';
export const SAVE_SEARCH_CHECK_REQUEST = 'la/ui/saveSearchCheck/REQUEST';
export const SAVE_SEARCH_CHECK_SUCCESS = 'la/ui/saveSearchCheck/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    isSavedSearch: false,
    savedSearchId: 0,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return DEFAULT_STATE;
        case SAVE_SEARCH_CHECK_FAIL:
            return {
                ...state,
                error: true,
                isSavedSearch: false,
                savedSearchId: 0,
                success: false,
            };
        case SAVE_SEARCH_CHECK_REQUEST:
            return {
                ...state,
                success: false,
            };
        case SAVE_SEARCH_CHECK_SUCCESS:
            const savedSearchId = action.payload || 0;
            const isSavedSearch = savedSearchId > 0;
            return {
                ...state,
                isSavedSearch,
                savedSearchId,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
export const getSaveSearchCheckState = (state: GlobalState) => state.saveSearchCheck;

export const getSavedSearchId = (state: GlobalState) => state.saveSearchCheck.savedSearchId;

/* ACTION CREATORS */
export const submitIsSavedSearchCheck = (ssParams: any, itemPageFacets: any) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        if (itemPageFacets) {
            ssParams = getItemSavedSearchQuery(itemPageFacets);
            if (!ssParams.category_id) {
                return new Promise(resolve => {
                    resolve(
                        dispatch({
                            type: SAVE_SEARCH_CHECK_SUCCESS,
                        })
                    );
                });
            }
        }
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        dispatch({
            type: SAVE_SEARCH_CHECK_REQUEST,
        });

        const response = await api.postIsSavedSearch({ authToken, deployment, ssParams });
        dispatch({
            payload: response.payload,
            type: SAVE_SEARCH_CHECK_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SAVE_SEARCH_CHECK_FAIL,
        });
    }
};
